import React from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SKILLS_POPUP } from '../../../assets/constants/skillsPopup';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '478px',
  minHeight: '216px',
  bgcolor: 'white',
  boxShadow: 24,
  p: 4,
};

export default function SkillAddedModal({ open, onClose, onAddMore, skillName }) {
  const { t } = useTranslation('library');
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="body1" sx={{ mb: 4, fontFamily: 'Lexend' }}>
          The <b>{skillName}</b> {t(SKILLS_POPUP.ADD_SUCCESS)}
        </Typography>
        <Typography variant="body1" sx={{ mb: 5, fontFamily: 'Lexend' }}>
          {t(SKILLS_POPUP.ADD_ANOTHER)}
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ fontFamily: 'Lexend', color: 'var(--accent)', textTransform: 'none' }}
          >
            {t(SKILLS_POPUP.ADD_SKILL_NO)}
          </Button>
          <Button
            variant="contained"
            onClick={onAddMore}
            sx={{ fontFamily: 'Lexend', backgroundColor: 'var(--accent)', textTransform: 'none' }}
          >
            {t(SKILLS_POPUP.ADD_MORE_SKILL)}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
